module.exports = __webpack_public_path__ + "img/logo.803bbb1a.png";